<form>
  <!-- Modal Header -->
  @if (isModal == true) {
    <div class="modal-header">
      <h4 class="modal-title">Bad Debt Simpan History = {{ selectedCustomerName }}</h4>
      <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" aria-label="Close" aria-label="Close" (click)="reset()"></button>
    </div>
  }

  <div class="modal-body">
    @if (bdTransactionList.length == 0 || bdTransactionList == undefined) {
      <div>This customer does not have any SIMPAN BD RECORD</div>
    } @else {
      <div class="container-fluid" style="padding: 2%">
        <div>
          <table class="table table-hover">
            <thead>
              <tr>
                @if (this.sharedService.isAdmin() == true || this.sharedService.isBossAccount() == true) {
                  <th></th>
                }
                <th>Date</th>
                <th>Remark</th>
                <th>Amount</th>
                <th>HandleBy</th>
              </tr>
            </thead>
            @for (bd of bdTransactionList; track bd) {
              <tr>
                @if (this.sharedService.isAdmin() == true || this.sharedService.isBossAccount() == true) {
                  <td>
                    <button class="btn btn-danger" (click)="confirmDeleteTranscation(bd)"><i class="fas fa-trash-alt"></i></button>
                  </td>
                }
                <td>
                  {{ bd.Date | date: "dd-MM-yyyy" }}
                </td>
                <td>
                  {{ bd.Remark }}
                </td>
                <td [ngClass]="checkAmountInOut(bd.Amount)">
                  {{ bd.Amount }}
                </td>
                <td>
                  {{ bd.HandleBy }}
                </td>
              </tr>
            }
            <tfoot>
              <tr>
                <td></td>
                <td><strong>Total:</strong></td>
                <td>
                  <strong>{{ calculateTotalBD(bdTransactionList) }}</strong>
                </td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    }
  </div>
</form>
